import { HTMLAttributes } from 'react';
import { Col, Row } from 'antd';
import { ServiceCard } from '../components';

const services = [
	{
		title: 'Staff Augmentation',
		services: ['Hire tech pros', 'AI-powered', 'Short-term projects'],
		actionLink: 'https://calendly.com/nanice-ahmed/30-min'
	},
	{
		title: 'Interview As a Service',
		services: ['Expert interviewers', 'Structured interviews', 'Tailored to identify best candidates'],
		actionLink: 'https://calendly.com/nanice-ahmed/30-min'
	},
	{
		title: 'CTO As a Service',
		services: ['Manage tech teams', 'No full-time CTO', 'Strategic tech decisions'],
		actionLink: 'https://calendly.com/nanice-ahmed/30-min'
	}
];

export const ServicesPayment: React.FC<HTMLAttributes<HTMLDivElement>> = () => {
	return (
		<>
			{/* <Row>
				<h2>Payment Of Other Services</h2>
			</Row> */}
			<Row className="d-flex justify-content-between" gutter={24}>
				{services.map(service => (
					<Col xs={24} md={8} key={service.title}>
						<ServiceCard
							title={service.title}
							services={service.services}
							actionLink={service.actionLink}
						/>
					</Col>
				))}
			</Row>
		</>
	);
};
